<template>
  <div class="wallet-takt-body color-3 t-rounded t-shadow font-weight-light"
    >
    <slot/>
  </div>
</template>
<script>
  export default {
    props: [],
    data: () => ({

    }),
  }
</script>
<style>
.wallet-takt-body {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100%;
  font-size: 20px;
  /* overflow: hidden; */
  user-select: none;
  z-index: 0;
}
</style>
